import React from "react";
import { SVGProps } from "../../svgData";

const CustomerIcon = ({
    defaultColor,
    selectedColor,
    isSelected,
}: SVGProps) => {
    const color = isSelected ? selectedColor : defaultColor;

    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="user-regular 1" clip-path="url(#clip0_1419_82458)">
                <path
                    id="Vector"
                    d="M13.5714 6.14397C13.5714 5.19677 13.1952 4.28836 12.5254 3.61859C11.8556 2.94882 10.9472 2.57254 10 2.57254C9.0528 2.57254 8.14439 2.94882 7.47462 3.61859C6.80485 4.28836 6.42857 5.19677 6.42857 6.14397C6.42857 7.09118 6.80485 7.99958 7.47462 8.66935C8.14439 9.33913 9.0528 9.7154 10 9.7154C10.9472 9.7154 11.8556 9.33913 12.5254 8.66935C13.1952 7.99958 13.5714 7.09118 13.5714 6.14397ZM4.28571 6.14397C4.28571 4.62845 4.88775 3.175 5.95939 2.10336C7.03103 1.03173 8.48448 0.429688 10 0.429688C11.5155 0.429688 12.969 1.03173 14.0406 2.10336C15.1122 3.175 15.7143 4.62845 15.7143 6.14397C15.7143 7.6595 15.1122 9.11295 14.0406 10.1846C12.969 11.2562 11.5155 11.8583 10 11.8583C8.48448 11.8583 7.03103 11.2562 5.95939 10.1846C4.88775 9.11295 4.28571 7.6595 4.28571 6.14397ZM2.20089 21.144H17.8036C17.4062 18.3181 14.9777 16.144 12.0446 16.144H7.96429C5.03125 16.144 2.60268 18.3181 2.20536 21.144H2.20089ZM0 21.9609C0 17.5636 3.5625 14.0011 7.95982 14.0011H12.0402C16.4375 14.0011 20 17.5636 20 21.9609C20 22.6931 19.4062 23.2868 18.6741 23.2868H1.32589C0.59375 23.2868 0 22.6931 0 21.9609Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_1419_82458">
                    <rect
                        width="20"
                        height="22.8571"
                        fill="white"
                        transform="translate(0 0.429688)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default CustomerIcon;
